import React, { Component } from 'react'
import MaskedInput from 'react-text-mask'

const MaskedInputWrap = props => {
    let {
        type = 'tfa_code',
        styles = '',
        value,
        readOnly = false,
        reference,
        guide = true,
        showMask = false,
        keepCharPositions = true,
        autoComplete = 'off',
        changeValue,
        placeholderChar,
        placeholder = '',
        pipe = null,
    } = props

    return (
        <MaskedInput
            mask={value => chooseMaskType(value, type)}
            className={styles}
            value={value}
            readOnly={readOnly}
            ref={ref => (reference ? reference(ref) : null)}
            guide={guide}
            showMask={props.showMask}
            keepCharPositions={props.keepCharPositions}
            autoComplete={autoComplete}
            onChange={props.changeValue}
            placeholderChar={props.placeholderChar}
            placeholder={placeholder}
            pipe={pipe}
        />
    )
}

const chooseMaskType = (value, type) => {
    if (type === 'passport-series_number') {
        if (isNaN(value.charAt(0)) === false) {
            return maskType['passport_series_v1']
        } else {
            return maskType['passport_series_v2']
        }
    } else if (type === 'passport-date_issue') {
        return maskType['passport_date_issue']
    } else {
        return maskType[type]
    }
}

const maskType = {
    tfa_code: [/\w/, ' ', /\w/, ' ', /\w/, ' ', /\w/, ' ', /\w/, ' ', /\w/],
    passport_series_v1: [
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        ' ',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
    ],
    passport_series_v2: [
        /[A-Z]/,
        /[A-Z]/,
        /[A-Z]/,
        ' ',
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
    ],
    passport_date_issue: [
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        /[0-9]/,
        '-',
        /[0-9]/,
        /[0-9]/,
        '-',
        /[0-9]/,
        /[0-9]/,
    ],
}

export default MaskedInputWrap
